(function() {
    'use strict';

    function CardsWidget() {
        this.$catLinks = $('.cat-list__link');
        this.$catMobileLinks = $('.cat-select');
        this.$cardsWrap = $('.card-list');
        this.mainUrl = 'https://' + location.host + '/apps/';
        this.desktopScreenWidth = 1024;
        this.cards = [];
        this.html = '';

        this.init();
    }

    CardsWidget.prototype.init = function() {
        this.switchTabRoute();
        this.animationScroll();

        window.onscroll = function() {
            if (window.innerWidth > this.desktopScreenWidth) {
                this.animationScroll();
            }
        }.bind(this);
    };

    CardsWidget.prototype.render = function(categoryUrl) {
        if (categoryUrl === this.mainUrl) {
            this.cards = window.apps.model.getCards();
        } else {
            this.cards = window.apps.model.getCardsByCategory(location.pathname);
        }

        window.apps.view.renderContent(this.$cardsWrap, this.cards);
    };

    CardsWidget.prototype.switchTabRoute = function() {
        History.Adapter.bind(
            window,
            'statechange',
            function() {
                var $activeCatLink = $('.cat-list__link.active');
                var categoryUrl = 'https://' + location.host + location.pathname;

                $activeCatLink.removeClass('active');

                this.$catLinks.each(function(index, category) {
                    var $category = $(category);

                    if ($category.attr('href') === location.pathname) {
                        $category.addClass('active');
                    }
                });

                this.render(categoryUrl);
            }.bind(this)
        );

        this.$catLinks.on('click touchstart', function(event) {
            var $link = $(event.target);
            var categoryUrl = $link.prop('href');
            var categoryTitle = $link.html();

            event.preventDefault();
            History.pushState(
                {
                    url: categoryUrl
                },
                categoryTitle,
                categoryUrl
            );
        });

        this.$catMobileLinks.on('change', function(eventMobileTap) {
            var $select = $(this);
            var categoryUrl = 'https://' + location.host + $select.val();
            var categoryTitle = $select.find('option:selected').text();

            eventMobileTap.preventDefault();
            History.pushState(
                {
                    url: categoryUrl
                },
                categoryTitle,
                categoryUrl
            );
        });
    };

    CardsWidget.prototype.animationScroll = function() {
        var $cards = $('.card-list__item');

        $cards.each(function() {
            var $card = $(this);

            if (
                $(document).scrollTop() + $(window).height() > $card.offset().top + 100 &&
                $(document).scrollTop() - $card.offset().top + 200 < $card.height()
            ) {
                $card.removeClass('card-list__item--minimized');
            }
        });
    };

    window.apps = window.apps || {};
    window.apps.CardsWidget = CardsWidget;
})();



// WEBPACK FOOTER //
// ./assets/js/projects/apps/widgets/cards.js